import * as angular from 'angular';
import * as angularTranslate from 'angular-translate';
import * as angulartics from 'angulartics';
import * as angularAnimate from 'angular-animate';
import * as uiPopover from 'angular-ui-bootstrap/src/popover';
import 'bootstrap-css-only';

import './style.less';
import { VideoSceneComponent } from './video-scene.component';
import { detectModule } from 'go-modules/detect';
import { VolumeIndicatorComponent } from '@go-modules/components/video-scene/volume-indicator/volume-indicator.component';
import { helpUrlsModule } from 'go-modules/help-urls';
import { ngxUnsavedDataManagerServiceModule } from '@go-modules/services/unsaved-data-manager';
import { messageModalModule } from 'go-modules/modals/message';
import { ngxMessageRememberingDialogModule } from '@go-modules/components/dialogs/message-remembering';
import { featureSupportModule } from 'go-modules/feature-support';
import { fullstoryModule } from 'go-modules/services/fullstory';
import { authServiceModule } from 'go-modules/services/auth';
import { trapTabIndexModule } from 'go-modules/trap-tab-index';
import { ngxGoToastModule } from '@go-modules/components/go-toast';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';
import { downgradeComponent } from '@angular/upgrade/static';
import { TimeDisplayComponent } from '@go-modules/components/time-display/time-display.component';
import { StatusOverlayComponent } from '@go-modules/components/video-scene/status-overlay/status-overlay.component';
import { SelectedModule } from 'go-modules/services/selected';
import { ngxMediaRecordingStatsModule } from '@go-modules/services/media-recording-stats';
import { ngxAspectRatioContainerModule } from '@go-modules/components/aspect-ratio-container';
import { ngxRealTimeCaptionsModule } from '@go-modules/components/real-time-captions';
import { ngxTimeRemainingCountdownModule } from '@go-modules/components/video-scene/time-remaining-countdown';
import { goAriaPressedLegacyModule } from '@go-modules/directives/aria-pressed';
import { templates } from './templates';
import { NgxDisabledInteractiveModule } from '@go-modules/directives/disabled-interactive';

export const videoSceneModule = angular
	.module('video-scene', [
		angularTranslate,
		angulartics,
		detectModule,
		helpUrlsModule,
		ngxUnsavedDataManagerServiceModule,
		messageModalModule,
		ngxMessageRememberingDialogModule,
		angularAnimate,
		uiPopover,
		featureSupportModule,
		fullstoryModule,
		trapTabIndexModule,
		authServiceModule,
		ngxGoToastModule,
		ngxFeatureFlagServiceModule,
		SelectedModule,
		ngxMediaRecordingStatsModule,
		ngxAspectRatioContainerModule,
		ngxRealTimeCaptionsModule,
		ngxTimeRemainingCountdownModule,
		goAriaPressedLegacyModule,
		NgxDisabledInteractiveModule
	])
	.component('videoScene', VideoSceneComponent)
	.directive('ngxTimeDisplay', downgradeComponent({ component: TimeDisplayComponent }))
	.directive('volumeIndicator', downgradeComponent({ component: VolumeIndicatorComponent }))
	.directive('ngxStatusOverlay', downgradeComponent({component: StatusOverlayComponent}))
	.run(templates)
	.name;
